import React from "react";
import { useParams } from "react-router-dom";
import {
  apiCallPost,
  initials,
  niceDate,
  niceDateTime,
  renderQuantityNice,
} from "../util/util";
import "../Discharge.css";
import QRCode from "react-qr-code";
import { Button, NonIdealState, Spinner, Tag } from "@blueprintjs/core";
import cogoToast from "cogo-toast";
import _ from "lodash";
import { planSectionDefaultStyle } from "./RxV21Cmp/ViewHelper";
import { bracketed, fixMedicineInsn, fixMedicineName } from "../util/util";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class DischargeLowerOrder extends React.Component {
  state = { isLoading: true, isFailure: false, sxId: null, hasLoaded: false };
  componentDidMount() {
    let ss = this.props.params.sxId;
    this.setState({ sxId: ss });
    if (ss) {
      this.getDischarge(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getDischarge = async (ss) => {
    try {
      let res = await apiCallPost("/print/sxDischargeSummary", {
        sxId: ss,
      });
      const renderOptions = res.branchInfo.rxRenderOptions;
      let dischargeEntities = res.dischargeEntities;
      if ((renderOptions.supressIPDRxSection || []).length > 0) {
        const supressSet = new Set(renderOptions.supressIPDRxSection);
        dischargeEntities = dischargeEntities.filter((e) => {
          const key = `${e.sectionName}!${e.subsectionName}`;
          if (supressSet.has(key)) {
            return false;
          }
          return true;
        });
      }
      this.setState(
        { isLoading: false, hasLoaded: true, ...res, dischargeEntities },
        () => {
          document.title = `${this.state.patientName} - ${this.state.branchInfo.hospital_name}`;
        }
      );
    } catch (err) {
      cogoToast.error("Failed to load discharge summary.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };

  renderHeader = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                alt="Client Logo"
                src={this.state.branchInfo.logoUrl}
                height="85px"
                width="auto"
                className="img_block"
              />
              <b
                style={{
                  fontSize: "9pt",
                  marginTop: "3px",
                  maxWidth: "120px",
                  textAlign: "center",
                }}
              >
                {this.state.branchInfo.hospital_name}
              </b>
            </div>
            <div>
              <b> {this.state.branchInfo.hospital_contact[0]}</b> <br />
              {this.state.branchInfo.hospital_contact[1]} <br />
              {this.state.branchInfo.hospital_contact[2]} <br />
              {this.state.branchInfo.hospital_contact[3]} <br />
              {this.state.branchInfo.ClinicPh} <br />
              {this.state.branchInfo.email} <br />
              Eye Bank: {this.state.branchInfo.EyeBankPh} <br />
              Insurance: {this.state.branchInfo.InsurancePh}
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              textAlign: "right",
              marginRight: "10px",
            }}
          >
            <div
              style={{
                marginLeft: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                textAlign: "right",
                maxWidth: "200px",
              }}
            >
              <div>
                <div style={{ textAlign: "left" }}>
                  {this.renderHorizontalText("DISCHARGE SUMMARY")}
                </div>
                <b style={{ fontSize: "large" }}> {this.state.patientName}</b>{" "}
                <br />
                PID: <b>{this.state.patientGenericPid}</b>
                <br />
                DoB: {niceDate(this.state.patientDob)} | Sex:{" "}
                {this.state.patientSex} <br />
                Phone: {this.state.patientPhone}
                <br />
                Address: {this.state.patientAddress}
                <br />
                Surgery Date: <b>{niceDate(this.state.onDay)}</b>
              </div>
            </div>
            <div
              style={{
                marginLeft: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <QRCode
                size={80}
                value={`https://print.newchart.care/discharge/${this.props.params.sxId}`}
                level="H"
              />
              <div
                style={{
                  fontSize: "x-small",
                  wordBreak: "break-all",
                  maxWidth: "150px",
                  textAlign: "center",
                }}
              >
                <code> {this.state.sxId}</code>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  renderDx = () => {
    let diagnosis = this.state.dischargeEntities.filter(
      (currentItem) =>
        currentItem.sectionName === "EXAMINATION" &&
        (currentItem.subsectionName === "OBSERVATIONS" ||
          currentItem.subsectionName === "DIAGNOSIS")
    );
    if (!diagnosis.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
        }}
      >
        {this.renderHorizontalText("DIAGNOSIS")}
        {diagnosis.map((each) => {
          return (
            <div
              className="vision__workup__tags"
              style={{ borderLeft: "2px solid black", marginBottom: "10px" }}
            >
              <Tag minimal multiline className="font__x__small">
                {each.entityName}
              </Tag>
              <Tag minimal multiline className="font__x__small bg__none">
                {each.eye === "RE"
                  ? "Right Eye"
                  : each.eye === "LE"
                  ? "Left Eye"
                  : each.eye === "BE"
                  ? "Both Eyes"
                  : this.state.eye}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };
  renderSxDetails = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("CLINICAL DETAILS")}</>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            {this.state.dischargeEntities.filter(
              (currentItem) =>
                currentItem.sectionName === "EXAMINATION" &&
                (currentItem.subsectionName === "OBSERVATIONS" ||
                  currentItem.subsectionName === "DIAGNOSIS")
            ).length === 1
              ? "Diagnosis: "
              : "Diagnoses: "}
            <b>
              {" "}
              {this.state.dischargeEntities
                .filter(
                  (currentItem) =>
                    currentItem.sectionName === "EXAMINATION" &&
                    (currentItem.subsectionName === "OBSERVATIONS" ||
                      currentItem.subsectionName === "DIAGNOSIS")
                )
                .map((each) => {
                  return `${
                    each.laterality === "BILATERAL"
                      ? "Both Eyes"
                      : `${_.upperFirst(_.lowerCase(each.laterality))} Eye:`
                  } ${each.entityName}`;
                })
                .join(", ")}
            </b>
          </Tag>
        </div>

        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Procedure Performed: <b>{this.state.lineItemsString}</b>
          </Tag>
        </div>

        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Operated Organ: <b>{this.state.eye}</b> | Anaesthesia:{" "}
            <b>{this.state.anaesthesiaType}</b>
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Surgeon: <b>{this.state.surgeonName}</b> | Anaesthesist:{" "}
            <b>{this.state.anaesthetistName}</b>
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Time of Admission:{" "}
            <b>
              {niceDateTime(
                _.filter(this.state.keyEvents, (k) => k.event === "Admission")
                  .length
                  ? _.filter(
                      this.state.keyEvents,
                      (k) => k.event === "Admission"
                    )[0].ts
                  : this.state.time
              )}
            </b>{" "}
            | Time of Discharge:{" "}
            <b>
              {niceDateTime(
                _.filter(this.state.keyEvents, (k) => k.event === "Discharge")
                  .length
                  ? _.filter(
                      this.state.keyEvents,
                      (k) => k.event === "Discharge"
                    )[0].ts
                  : new Date()
              )}
            </b>
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Discharge Notes: <b>{this.state.dischargeNotes}</b>
          </Tag>
        </div>
      </div>
    );
  };
  renderMedicines = () => {
    let meds = this.state.dischargeEntities.filter(
      (currentItem) =>
        currentItem.sectionName === "PLAN" &&
        currentItem.subsectionName === "MEDICATIONS"
    );
    if (!meds.length) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "10px",
          }}
        >
          <>{this.renderHorizontalText("MEDICINES")}</>
          <div className="font__x__small">
            No additional medicines prescribed at this time. Please adhere to
            instructions and advice given.
          </div>
        </div>
      );
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("MEDICINES")}</>

        {meds.map((entity, index) => {
          let elements = [];
          let firstLine = [];
          firstLine.push(<>{index + 1}. </>);
          if (entity.laterality && entity.organ === "EYE") {
            if (entity.laterality === "LEFT") {
              firstLine.push(<b>LE - </b>);
            } else if (entity.laterality === "RIGHT") {
              firstLine.push(<b>RE - </b>);
            } else {
              firstLine.push(<b>BE - </b>);
            }
          }
          firstLine.push(
            <b style={planSectionDefaultStyle.bulletPointTitleStyle}>
              {fixMedicineName(entity.entityName)}
            </b>
          );
          if (entity.notes) {
            firstLine.push(<> ({entity.notes})</>);
          }
          if (entity.molecule) {
            elements.push(<> ({entity.molecule}) </>);
          }
          if (entity.instructions) {
            let text = <></>;
            if (entity.subsectionName === "MEDICATIONS") {
              let t = entity.instructions.split(";");
              t = t.map((entity) => entity.split(","));
              t = _.flatten(t);
              t = t.map((entity) => _.upperFirst(entity.trim()));
              text = (
                <>
                  {t.map((entity) => {
                    return <div>{fixMedicineInsn(entity)}</div>;
                  })}
                </>
              );
            } else {
              text = entity.instructions
                .split(",")
                .map((insn) => _.upperFirst(insn.trim()))
                .map((f) => <div>{f}</div>);
            }
            elements.push(
              <div style={planSectionDefaultStyle.instructionStyle}>{text}</div>
            );
          }

          if (entity.anaesthesia) {
            let niceStrings = {
              TOPICAL_ANAESTHESIA: "TA",
              LOCAL_ANAESTHESIA: "LA",
              REGIONAL_ANAESTHESIA: "RA",
              GENERAL_ANAESTHESIA: "GA",
            };
            elements.push(<>↓: {niceStrings[entity.anaesthesia]} </>);
          }
          if (entity.sxLinkedInvestigations) {
            let niceStrings = {
              BIOMETRY_OCT_SPECULAR: "Biometry, OCT and Specular",
              BIOMETRY_OCT_SYRINGING_SPECULAR:
                "Biometry, OCT, Syringing and Specular",
              OCT_DFP: "OCT and DFP",
              "ECG_X-RAY_PPBS": "ECG, X-Ray and PPBS",
            };
            elements.push(" | Pre-Surgery Investigations: ");
            elements.push(niceStrings[entity.sxLinkedInvestigations]);
            if (entity.notes) {
              elements.push(` (${entity.notes})`);
            }
          }

          return (
            <div style={planSectionDefaultStyle.subSectionBulletPoint}>
              <div>
                {firstLine.map((entity) => {
                  return <>{entity}</>;
                })}
              </div>

              {elements.map((entity) => (
                <div>{entity}</div>
              ))}
            </div>
          );
        })}

        {/* {meds.map((each) => {
          return (
            <div
              className="vision__workup__tags"
              style={{ borderLeft: "2px solid black", marginBottom: "10px" }}
            >
              <Tag minimal multiline className="font__x__small">
                {each.entityName}
              </Tag>

              {each.molecules && (
                <Tag minimal multiline className="font__x__small bg__none">
                  {" [ "}
                  <b>{each.molecules}</b>
                  {" ] "}
                </Tag>
              )}

              {each.laterality && (
                <Tag minimal multiline className="font__x__small bg__none">
                  {" | "}
                  <b>{each.laterality}</b>
                </Tag>
              )}

              {each.instructions && (
                <Tag minimal multiline className="font__x__small bg__none">
                  {" | "}
                  {each.instructions}
                </Tag>
              )}
            </div>
          );
        })} */}
      </div>
    );
  };
  renderSurgicalNotes = () => {
    let surgicalNotes = this.state.dischargeEntities.filter(
      (currentItem) =>
        currentItem.sectionName === "SURGERY" &&
        currentItem.subsectionName === "SURGICAL_NOTES"
    );
    if (!surgicalNotes.length) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "10px",
          }}
        >
          <>{this.renderHorizontalText("SURGICAL NOTES")}</>
          <div className="font__x__small">
            No additional surgical notes available at this time.
          </div>
        </div>
      );
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("SURGICAL NOTES")}</>

        {surgicalNotes.map((each) => {
          return (
            <div
              className="vision__workup__tags"
              style={{ marginBottom: "5px" }}
            >
              <Tag
                minimal
                multiline
                className="font__x__small bg__none"
                style={{ lineHeight: "20px" }}
              >
                {each.entityName}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };

  renderAdvice = () => {
    let adv = this.state.dischargeEntities.filter(
      (currentItem) =>
        currentItem.sectionName === "PLAN" &&
        currentItem.subsectionName === "ADVICE"
    );

    if (!adv.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("ADVICE")}</>

        {adv.map((each) => {
          return (
            <div
              className="vision__workup__tags"
              style={{ marginBottom: "5px" }}
            >
              <Tag minimal multiline className="font__x__small bg__none">
                {`• ${each.entityName}`}
              </Tag>
              <Tag minimal multiline className="font__x__small bg__none">
                {each.instructions}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };
  renderFU = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("FOLLOW UP")}</>

        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Follow Up Appointment: {this.state.followUpAppt}
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            In case you experience pain, swelling, redness, sudden drop in
            vision, injury to the operated eye or any other discomfort, please
            contact us immediately, or visit the nearest branch of the hospital.
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            {this.state.postSxContact} You can also call us on{" "}
            {this.state.branchInfo.ClinicPh} or on 03366360000 between 8 am to 5
            pm to reach the hospital help desk.
          </Tag>
        </div>
      </div>
    );
  };
  renderDoc = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          marginLeft: "10px",
          textAlign: "right",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ fontSize: "large" }}>
            <b>{this.state.resourceInfo.name}</b>
          </div>
          <div className="font__small">
            <b>{this.state.resourceInfo.qualifications}</b>
          </div>
          <div className="font__small">
            Registration: <b>{this.state.resourceInfo.mrNumber}</b>
          </div>
        </div>
      </div>
    );
  };
  renderItems = () => {
    if (!this.state.consumedItems) {
      return null;
    }
    if (!this.state.consumedItems.length) {
      return null;
    }
    return (
      <div>
        <div>
          {this.renderHorizontalText("ITEMS IMPLANTED/USED IN SURGERY")}
        </div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>#</th> <th>Item</th>
              <th>Batch/Serial</th>
              <th>Expiry Date</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>{this.renderEachItem()}</tbody>
        </table>
      </div>
    );
  };
  renderEachItem = () => {
    if (!this.state.consumedItems) {
      return null;
    }
    if (!this.state.consumedItems.length) {
      return null;
    }
    return this.state.consumedItems.map((each, index) => {
      return (
        <tr>
          <td>{index + 1}</td>
          <td>{each.itemName}</td>
          <td>{each.inventoryDetails.serialNumber}</td>
          <td>{niceDate(each.inventoryDetails.expiresOn)}</td>
          <td>
            {renderQuantityNice(
              each.inventoryDetails.quantity,
              each.inventoryDetails.subunitOfConsumption,
              each.itemUnitName,
              each.itemSubunitName
            )}
          </td>
        </tr>
      );
    });
  };
  renderVerticalText = (text, isProminent = true) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          textOrientation: "upright",
          writingMode: "vertical-rl",
          marginRight: "10px",
          fontSize: "xx-small",
          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  renderHorizontalText = (text, isProminent = false) => {
    return (
      <div
        style={{
          backgroundColor: "#E6E7E7",
          marginBottom: "10px",
          fontSize: "110%",
          letterSpacing: "1mm",

          border: `${isProminent ? "1px solid #b8a09e" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  renderTimeStamp = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          marginLeft: "10px",
          textAlign: "left",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="font__small">
            Last Updated: {niceDate(this.state.updatedAt)}
          </div>
          {this.state.consumedItems && this.state.consumedItems.length ? (
            <div className="font__small" style={{ maxWidth: "50vw" }}>
              Items as listed above are not an exhaustive list. Please contact
              the hospital surgery desk for a complete list.
            </div>
          ) : null}
        </div>
      </div>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div className="center_screen">
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isFailure) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    if (!this.state.hasLoaded) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    if (
      !["SX_DONE", "DISCHARGED", "LAMA", "DEATH", "CANCELLED"].includes(
        this.state.lifecycle
      )
    ) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="This patient has not been discharged yet."
          />
        </div>
      );
    }
    return (
      <div
        className="rx__container"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {" "}
        <style type="text/css" media="print">
          {" @page { size: A4 portrait !important; margin: 7mm !important;"}
        </style>
        <div>
          <div className="no__print">
            <Button
              icon="print"
              text="Print"
              onClick={() => {
                window.print();
              }}
              fill
            />{" "}
          </div>
          {this.renderHeader()}
          <hr />

          {this.renderSxDetails()}

          {this.renderMedicines()}

          {/* {this.renderDx()} */}
          {this.renderAdvice()}
          {this.renderFU()}
          {this.renderSurgicalNotes()}

          {this.renderItems()}
        </div>
        <div style={{ position: "fixed", bottom: "0", width: "100vw" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "5x",
              marginLeft: "10px",
              textAlign: "right",
            }}
          >
            <>{this.renderHorizontalText("SURGEON")}</>
          </div>
          <hr />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {" "}
            <div> {this.renderTimeStamp()}</div>
            <div> {this.renderDoc()}</div>
          </div>
        </div>
      </div>
    );
  }
}

const Discharge = withRouter(DischargeLowerOrder);
export default Discharge;
